const device = [{

  title: "停线求助",
  img: "andon_home",
  img1: "andon_tv",
  t1: "发起求助",
  c1: "现场员工通过玩转工厂App，向现场对应问题的支持人员，创建Andon求助任务，任务中包含产线、问题描述、图片等资料",
  t2: "处置求助",
  c2: "支持人员收到求助任务之后，对此任务报告的相关问题进行处置，如无法独立处置时可以邀请更多帮手参与至此问题的解决中来",
  t3: "升级报警",
  c3: "为解决问题设置多个报警时限，当超过设置时限时，系统根据设置的规则（如：自动逐级向主管，经理，厂长发送报警信息）进行任务处置超时的上报与报警",
  t4: "可视化数据展示",
  c4: "大屏幕实时展示生产状态，当发生求助任务时或者任务升级报警时，通过音响进行自动广播通知（如：注塑机发生故障停机，需要维修员张三的支持），同时管理者可以通过手机随时主动监控现场的状态。 ",
  t5: "统计分析",
  c5: "后台AI服务器基于停线数据和空转计时数据以及统计规则，进行自动计算停线次数和时间，并通过设备和因素两个维度分析停线的原因及MTTR/MTFB以及OEE的智能分析",
}, {

  title: "空转计时",
  img: "andon_home",
  t1: "发起计时",
  c1: "现场员工通过玩转工厂App，创建空转计时任务，任务中包含产线、计时类型（员工培训、试模调试、维护保养、快速换型、开机关机、项目生产、返工生产，总计7项）、描述、图片等资料",
  t2: "关闭计时",
  c2: "对应计时停止时，结束计时统计并关闭计时任务",
  t3: "可视化数据展示",
  c3: "谢谢 ",
  t4: "统计分析",
  c4: "后台AI服务器基于停线数据和空转计时数据以及统计规则，进行自动计算停线次数和时间，并通过设备和因素两个维度分析停线的原因及MTTR/MTFB以及OEE的智能分析",
}, {
  title: "设备异常",
  img: "",
}, {
  title: "设备点检",
  img: "",
}, {
  title: "备件申请",
  img: "",
}];
const quality = [{

  title: "班末总结",
  img: "",
  t1: "t1大字描述",
  c1: "c2大字描述",
  t2: "大字描述",
  c2: "详细描述"
}, {

  title: "不合格品",
  img: "",
  t1: "t1大字描述",
  c1: "c2大字描述",
  t2: "大字描述",
  c2: "详细描述"
}, {
  title: "质量门",
  img: "",
  t1: "t1大字描述",
  c1: "c2大字描述",
  t2: "大字描述",
  c2: "详细描述"
}, {
  title: "分层审核",
  img: "",
  t1: "t1大字描述",
  c1: "c2大字描述",
  t2: "大字描述",
  c2: "详细描述"
}, {
  title: "4M变化点",
  img: "",
  t1: "t1大字描述",
  c1: "c2大字描述",
  t2: "大字描述",
  c2: "详细描述"
}, {
  title: "模具问题",
  img: "",
  t1: "t1大字描述",
  c1: "c2大字描述",
  t2: "大字描述",
  c2: "详细描述"
}, {
  title: "质量检验",
  img: "",
  t1: "t1大字描述",
  c1: "c2大字描述",
  t2: "大字描述",
  c2: "详细描述"
}, {
  title: "7大浪费",
  img: "",
  t1: "t1大字描述",
  c1: "c2大字描述",
  t2: "大字描述",
  c2: "详细描述"
}, {
  title: "客户质量",
  img: "",
  t1: "t1大字描述",
  c1: "c2大字描述",
  t2: "大字描述",
  c2: "详细描述"
}, {
  title: "工位平衡",
  img: "",
  t1: "t1大字描述",
  c1: "c2大字描述",
  t2: "大字描述",
  c2: "详细描述"
}, {
  title: "交接班",
  img: "",
  t1: "t1大字描述",
  c1: "c2大字描述",
  t2: "大字描述",
  c2: "详细描述"
}];
const user = [{
  title: "技能培训",
  img: "",
  t1: "t1大字描述",
  c1: "c2大字描述",
  t2: "大字描述",
  c2: "详细描述"
}, {
  title: "人员培训",
  img: "",
  t1: "t1大字描述",
  c1: "c2大字描述",
  t2: "大字描述",
  c2: "详细描述"
}, {
  title: "安全风险",
  img: "",
  t1: "t1大字描述",
  c1: "c2大字描述",
  t2: "大字描述",
  c2: "详细描述"
}, {
  title: "5S改善",
  img: "",
  t1: "t1大字描述",
  c1: "c2大字描述",
  t2: "大字描述",
  c2: "详细描述"
}, {
  title: "改善提案",
  img: "",
  t1: "t1大字描述",
  c1: "c2大字描述",
  t2: "大字描述",
  c2: "详细描述"
}, {
  title: "公司公告",
  img: "",
  t1: "t1大字描述",
  c1: "c2大字描述",
  t2: "大字描述",
  c2: "详细描述"
}, {
  title: "疫病防控",
  img: "",
  t1: "t1大字描述",
  c1: "c2大字描述",
  t2: "大字描述",
  c2: "详细描述"
}];

const products = {
  title: '我们的产品',
  type: [{
    title: "停线求助",
    img: "andon_home",
    img1: "andon_tv",
    img1Title: "Andon智慧看板",
    img2: "000_tv0",
    img3: "000_tv1",
    t1: "发起求助",
    c1: "现场员工通过玩转工厂App，向现场对应问题的支持人员，创建Andon求助任务，任务中包含产线、问题描述、图片等资料",
    t2: "处置求助",
    c2: "支持人员收到求助任务之后，对此任务报告的相关问题进行处置，如无法独立处置时可以邀请更多帮手参与至此问题的解决中来",
    t3: "升级报警",
    c3: "为解决问题设置多个报警时限，当超过设置时限时，系统根据设置的规则（如：自动逐级向主管，经理，厂长发送报警信息）进行任务处置超时的上报与报警",
    t4: "可视化数据展示",
    c4: "大屏幕实时展示生产状态，当发生求助任务时或者任务升级报警时，通过音响进行自动广播通知（如：注塑机发生故障停机，需要维修员张三的支持），同时管理者可以通过手机随时主动监控现场的状态 ",
    t5: "统计分析",
    c5: "后台AI服务器基于停线数据和空转计时数据以及统计规则，进行自动计算停线次数和时间，并通过设备和因素两个维度分析停线的原因及MTTR/MTFB以及OEE的智能分析",
  }, {
    title: "空转计时",
    img: "001_m",
    img1: "andon_tv",
    img1Title: "Andon智慧看板",
    t1: "发起计时",
    c1: "现场员工通过玩转工厂App，创建空转计时任务，任务中包含产线、计时类型（员工培训、试模调试、维护保养、快速换型、开机关机、项目生产、返工生产，总计7项）、换形产品、描述、图片等资料",
    t2: "关闭计时",
    c2: "对应计时停止时，结束计时统计并关闭计时任务",
    t3: "可视化数据展示",
    c3: "大屏幕实时展示生产状态，同时管理者可以通过手机随时主动监控现场的状态 ",
    t4: "统计分析",
    c4: "后台AI服务器基于停线数据和空转计时数据以及统计规则，进行自动计算停线次数和时间，并通过设备和因素两个维度分析停线的原因及MTTR/MTFB以及OEE的智能分析",
  }, {
    title: "设备异常",
    img: "002_m",
    img1: "002_tv",
    img1Title: "设备异常智慧看板",
    t1: "创建异常任务",
    c1: "现场员工通过玩转工厂App，创建设备异常任务，任务中包含产线、设备、工位、异常类型（可自定义）、负责人、描述、图片等资料",
    t2: "处置异常任务",
    c2: "负责人通过对接收到的任务进行PDCA流程处置（分析问题、整改方案、执行实施、检查确认、经验总结），也可以进行责任人转移以及添加帮手人员参与此任务，后续也可以对整改任务进行审核、审批等等操作",
    t3: "可视化数据展示",
    c3: "大屏幕实时展示异常设备、异常原因、负责人、处置进度等等状态，同时管理者可以通过手机随时主动监控设备生产的状态 ",
    t4: "统计分析",
    c4: "后台AI服务器基于设备异常数据以及统计规则，进行自动计算异常类型、原因、时间、发布等等，并将计算出的数据进行统一展示",
  }, {
    title: "生产启动",
    img: "andon_home",
    img1: "003_tv0",
    img1Title: "生产启动（点检）智慧看板",
    img2: "003_tv1",
    t1: "点检任务",
    c1: "为对应的设备、产品、人员配置对应的点检表，相应人员可以在开班、班末进行定性（合格或者不合格）、定量（数值类型）点检，如有不合格整改任务时，将进入不合格整改任务环节；可以对点检结果进行PDF导出",
    t2: "不合格整改任务",
    c2: "当有点检项不合格时，将生成点检不合格整改任务，后续可对其不合格进行PDCA流程处置",
    t3: "可视化数据展示",
    c3: "大屏幕实时展示生产启动（设备点检）状态、进度、不合格处置结果，同时管理者可以通过手机随时主动监控现场的状态 ",
    t4: "统计分析",
    c4: "后台AI服务器基于生产启动计划以及任务相关数据和统计规则，进行自动计算当前时间下需要做的任务以及任务的具体完成状态",
  }, {
    title: "备件管理",
    img: "004_m",
    t1: "备件申请",
    c1: "备件申请人员选择备件、出库类型、涉及设备、数量、申请内容等等相关信息，并创建备件申请任务，交由相应人员进行审批",
    t2: "备件审批",
    c2: "相应的审批人员对备件申请进行审批操作",
    t3: "备件管理",
    c3: "对库存备件进行盘点、入库、出库、删除等操作，并且留存操作相关操作记录用于后续分析处理",
    t4: "统计分析",
    c4: "后台AI服务器基于备件申请记录数据以及统计规则，进行自动计算并进行分析",
  }, {
    title: "班末总结",
    img: "005_m",
    img1: "005_tv0",
    img1Title: "班末总结智慧看板",
    img2: "005_tv1",
    img3: "005_tv2",
    t1: "班末报产",
    c1: "班长可根据排班计划生成的生产任务中填写实际的产量、不合格、返工等，以及计划停机时间、生产过程中的异常事件等；也可以在没有排产计划的情况下，手动添加实际生产情况",
    t3: "可视化数据展示",
    c3: "大屏幕实时展示生产状态，同时管理者可以通过手机随时主动监控现场的状态 ",
    t4: "统计分析",
    c4: "后台AI服务器基于计划产量、实际产量、异常停机时间、计划停机时间等数据以及统计规则，进行自动计算停线次数和时间，展示生产情况，搭配停线求助功能会使数据更加丰富，展示OEE、TRS等详细分析，具体可查看Andon介绍",
  }, {
    title: "不合格品",
    img: "006_m",
    img1: "006_tv0",
    img1Title: "不合格品智慧看板",
    t1: "创建不合格任务",
    c1: "现场员工通过玩转工厂App，选择产线、工位、产品、原因、检测方法、数量、图文描述等，选定负责人之后创建不合格处置任务，",
    t2: "不合格品处置",
    c2: "负责人员对上报的不合格品进行处置（合格、报废、返工、返修、拆解），并且对产生问题原因进行归类、分析",
    t3: "报警升级",
    c3: "在配置的升级规则情况下，当产生的不合格品达到设置的规则时，系统会根据升级规则自动向相应的负责员推送通知，提醒关注",
    t4: "可视化数据展示",
    c4: "大屏幕实时展示不合格品产生以及处置进度、状态，同时管理者可以通过手机随时主动监控现场的状态 ",
    t5: "统计分析",
    c5: "后台AI服务器基于不合格任务数据以及统计规则，并获取对应产线、产品进行自动计算，根据计算结果归类分析问题原因",
  }, {
    title: "质量门",
    img: "007_m",
    img1: "006_tv0",
    img1Title: "不合格品(质量门)智慧看板",
    t1: "创建质量门任务",
    c1: "根据质量门原因、产线、产品、检验、升级规则、负责人、项目等，建立质量门计划，并对其涉及的产品按计划进行不合处置",
    t2: "创建不合格任务",
    c2: "现场员工通过玩转工厂App，选择产线、工位、产品、原因、检测方法、数量、图文描述等，选定负责人之后创建不合格处置任务，",
    t3: "不合格品处置",
    c3: "负责人员对上报的不合格品进行处置（合格、报废、返工、返修、拆解），并且对产生问题原因进行归类、分析",
    t4: "报警升级",
    c4: "在配置的升级规则情况下，当产生的不合格品达到设置的规则时，系统会根据升级规则自动向相应的负责员推送通知，提醒关注",
    t5: "统计分析",
    c5: "后台AI服务器基于质量门、不合格任务数据以及统计规则，并获取对应产线、产品进行自动计算，根据计算结果归类分析问题原因",
  }, {
    title: "分层审核",
    img: "008_m",
    img1: "008_tv0",
    img1Title: "分层审核智慧看板",
    t1: "配置审核计划",
    c1: "管理人员在玩转工厂Web页面配置分层审核计划，并将其指定与对应的人员",
    t2: "审核任务",
    c2: "现场员工通过玩转工厂App，系统会自动根据审批计划分配给对应人员应该审核的任务，收到分层审核任务的人员可以对其处置（合格、不适用、不合格、已纠正），可以填写区域、产线、工位、产品、班组、班次等信息，让后续数据处理更加详细",
    t3: "不合格整改",
    c3: "对分层审核任务中分层审核项进行处置，发现不合格项时生成整改任务，后续使用PDCA流程对不整改任务进行处置",
    t4: "可视化数据展示",
    c4: "大屏幕实时展示分层审核计划、分层审核任务、分层审核整改任务实时的进度、状态、结果，同时管理者可以通过手机随时主动监控分层审核的状态 ",
    t5: "统计分析",
    c5: "后台AI服务器基于分层审核计划、任务、整改任务以及统计规则，进行自动计算汇总，并以报表的形式予以呈现",
  }, {
    title: "4M变化点",
    img: "009_m",
    img1: "009_tv0",
    img1Title: "4M变化点智慧看板",
    t1: "创建4M变化任务",
    c1: "现场员工通过玩转工厂App，识别人、机、料、法、环、测并创建变化任务进行管理",
    t2: "变化点任务处置",
    c2: "选择验证方案（如：新人新岗）、验证人员对其进行变化点验证，对应验证过程进行记录，并且得出结论（验证OK、验证NOK）且记录断点，再由相应人员进行检查确认，最终由负责人员得出结论对当前变化点进行关闭（正式化、重新验证、恢复原状）且记录断点信息",
    t3: "可视化数据展示",
    c3: "大屏幕实时展示变化点任务、进度、状态、分布，同时管理者可以通过手机随时主动监控变化点的状态 ",
    t4: "统计分析",
    c4: "后台AI服务器基于变化点数据以及统计规则，进行自动计算并分析相关数据，将分析数据以报表的形式呈现",
  }, {
    title: "模具问题",
    img: "010_m0",
    img1: "010_tv0",
    img1Title: "模具问题智慧看板",
    t1: "模具问题报告",
    c1: "现场员工通过玩转工厂App，创建模具问题任务，任务中包含模具、问题类型（可根据需求自定义）、负责人、描述、图片等资料",
    t2: "模具问题处置",
    c2: "模具任务的负责人人员，通过PDCA处置流程对模具问题进行处置",
    t3: "可视化数据展示",
    c3: "大屏幕实时展示模具问题的状态以及处置进度，同时管理者可以通过手机随时主动监控 ",
    t4: "统计分析",
    c4: "后台AI服务器基于模具问题报告记录以及统计规则，进行自动计算，并将计算出的数据以报表的形式呈现",
  }, {
    title: "质量检验",
    img: "011_m0",
    t1: "建立质量检验任务",
    c1: "现场员工通过玩转工厂App，创建质量检验任务，任务中包含产线、工位、检验类别（可自定义）、产品、项目、取样方法、数量、负责人、描述、图片等资料",
    t2: "处置质量检验任务",
    c2: "当前任务对应的负责人，通过PDCA处置流程，对当前质量检验任务进行规范的处置",
    t3: "统计分析",
    c3: "后台AI服务器基于质量检验的记录以及统计规则，进行自动计算，并通过以报表的形式呈现",
  }, {
    title: "7大浪费",
    img: "012_m0",
    img1: "012_tv0",
    img1Title: "7大浪费智慧看板",
    t1: "报告7大浪费问题",
    c1: "现场员工通过玩转工厂App，创建7大浪费任务，任务中包含产线、非生成设备、区域、浪费类型（可自定义）、负责人、描述、图片等资料",
    t2: "处置问题",
    c2: "负责人员对7大浪费问题根据PDCA处置流程进行处置，处置结果将在记录中汇总呈现",
    t3: "可视化数据展示",
    c3: "大屏幕实时展示7大浪费问题以及处置进度、状态，同时管理者可以通过手机随时主动监控 ",
    t4: "统计分析",
    c4: "后台AI服务器基于7大浪费汇总数据以及统计规则，进行自动计算并且以报表的形式呈现",
  }, {
    title: "客户质量",
    img: "013_m0",
    img1: "013_tv0",
    img1Title: "客户质量智慧看板",
    t1: "创建客户质量任务",
    c1: "现场员工通过玩转工厂App，创建客户质量任务，任务中包含发起问题人、时间、地点、涉及产线、产品、客户、项目、问题类型（可自定义）、负责人、描述、图片等资料",
    t2: "处置客户质量任务",
    c2: "接收到任务的负责人员，根据PDCA处置流程，对客户质量报告的问题进行处置，并得出结论",
    t3: "可视化数据展示",
    c3: "大屏幕实时展示客户质量任务处置进度、状态，同时管理者可以通过手机随时主动监控客户质量的状态",
    t4: "统计分析",
    c4: "后台AI服务器基于客户质量数据、产品数据以及统计规则，进行汇总分析，并以报表的形式呈现",
  }, {
    title: "工位平衡",
    img: "014_m0",
    t1: "创建工位平衡",
    c1: "现场员工通过玩转工厂App，创建工位平衡任务，任务中包含产线、产品、人数等资料",
    t2: "得出结论",
    c2: "运行结束时，自动生成工位平衡图，得出标准工时",
    t3: "统计分析",
    c3: "后台AI服务器基于工位平衡数据、标准工时以及统计规则，进行自动计算并予以展示记录",
  }, {
    title: "交接班",
    img: "015_m0",
    t1: "创建交接班任务",
    c1: "现场员工通过玩转工厂App，创建交接班任务，任务中包含班组信息、上个班组生产期间生产的事件（不合格品、安全风险、停机事件、质量报警、设备异常、4M变化点、安全事故）、描述、图片等资料",
    t2: "接班处置",
    c2: "接班班长对上班任务进行核实，确认无误进行交接",
    t3: "统计分析",
    c3: "系统自动根据获取停机事件、不合格品、安全风险、停机事件、质量报警、设备异常、4M变化点、安全事故、班末总结、班组信息等等，进行汇总计算",
  }, {
    title: "技能培训",
    img: "016_m0",
    img1: "016_tv0",
    img1Title: "岗位技能&上岗人员智慧看板",
    t1: "创建技能培训任务",
    c1: "现场员工通过玩转工厂App，创建岗位技能培训任务，任务中包含产线、技能、来源、讲师、地点、时间、描述、图片等资料",
    t2: "技能培训",
    c2: "在规定时间与地点，通过对学员的培训，来提升学员的技能与多岗位能力",
    t3: "课程评价与技能审批",
    c3: "学员对讲师、课程进行打分、评价，讲师、负责人对学员技能的提升进行审核、审批，确认学员获得此技能",
    t4: "岗位技能与上岗人员",
    c4: "大屏幕实时展示公司人员技能、上岗状态，同时管理者可以通过手机随时主动监控现场的上岗状态 ",
    t5: "统计分析",
    c5: "后台AI服务器基于员工技能、产线、工位、产品以及统计规则，进行自动计算员工的技能等级、有效期、是否需要培训，是否正常上岗",
  }, {
    title: "人员培训",
    img: "017_m0",
    t1: "创建人员培训任务",
    c1: "现场员工通过玩转工厂App，人员、培训原因（如：新员工入职，可自定义）、培训类型（如：新员工，可自定义）、描述、图片等资料",
    t2: "人员培训结果与课程评价",
    c2: "负责人、讲师等对培训结果进行评价，学员也可以对讲师、课程进行打分评价",
    t3: "统计分析",
    c3: "后台AI服务器基于人员培训记录以及统计规则，进行自动计算与统计展示",
  }, {
    title: "安全风险",
    img: "018_m0",
    img1: "018_tv0",
    img1Title: "安全风险智慧看板",
    t1: "报告安全风险问题",
    c1: "现场员工通过玩转工厂App，报告安全风险问题，问题中包含发起人、产线、设备、工位、产品、项目、客户、负责人、描述、图片等资料",
    t2: "安全风险问题处置",
    c2: "负责人员对报告的安全风险问题，按照PDCA规范流程进行处置，并得到结果与收益",
    t3: "可视化数据展示",
    c3: "大屏幕实时展示安全风险问题的处置进度、状态，同时管理者可以通过手机随时主动监控风险的状态",
    t4: "统计分析",
    c4: "后台AI服务器基于安全风险问题数据以及统计规则和相关的产线、工位等汇总计算，最终以记录、图表的形式呈现",
  }, {
    title: "5S改善",
    img: "019_m0",
    img1: "019_tv0",
    img1Title: "5S改善智慧看板",
    t1: "提交5S改善任务",
    c1: "现场员工通过玩转工厂App，创建空转计时任务，任务中包含产线、工位、非生产设备、区域、负责人、描述、图片等资料",
    t2: "处置5S改善任务",
    c2: "负责人对接收到的5S改善任务，按照PDCA规范流程进行处置，得出5S改善结果",
    t3: "可视化数据展示",
    c3: "大屏幕实时展示5S改善任务的状态，处置进度、原因分析等，同时管理者可以通过手机随时主动监控当前状态 ",
    t4: "统计分析",
    c4: "后台AI服务器基于5S改善任务记录涉及的数据以及统计规则，进行5S改善的原因分析与收益分析，并且以报表、记录的形式展现",
  }, {
    title: "改善提案",
    img: "020_m0",
    img1: "020_tv0",
    img1Title: "改善提案智慧看板",
    t1: "提交改善提案",
    c1: "现场员工通过玩转工厂App，创建改善提案，提案中包含来源、类别、当前状态、建议方案，描述、图片等资料",
    t2: "审核提案",
    c2: "负责人员对提交的提案进行及时答复，判断是否采纳，提供及时的反馈，提高人员参与的积极性",
    t3: "可视化数据展示",
    c3: "大屏幕实时展示提案的处置进度、状态、反馈进度、历史提案分析，同时管理者可以通过手机随时主动监控提案状态以及结果",
    t4: "统计分析",
    c4: "后台AI服务器基于改善提案数据以及统计规则，进行自动计算改善提案记录、回复、通过等情况，汇总展示",
  }, {
    title: "维护保养",
    img: "021_m0",
    img1: "021_tv0",
    img1Title: "维护保养智慧看板&模具管理智慧看板",
    img2: "021_tv1",
    t1: "立即维护保养计划",
    c1: "负责人员根据设备、模具、非生产设备等，创建预防性维护保养计划，配置维护保养内容、方法、预期结果、指导书等信息",
    t2: "周期维护保养任务",
    c2: "系统根据保养计划中配置的信息，进行定期给对应的维护保养负责人生成预防性维护保养任务",
    t3: "模次维护保养任务",
    c3: "系统基于产量、时间进行科学计算设备、模具的状态，以及是否需要进行预防性维护，如到达维护阈值时，系统将给对应的负责人生成维护保养任务",
    t4: "可视化数据展示",
    c4: "大屏幕实时展示周期预防性维护保养与模次预防性维护保养状态，维护进度、设备寿命等等信息，同时管理者可以通过手机随时主动监控现场的维护保养进度状态 ",
    t5: "统计分析",
    c5: "后台AI服务器基于产量、时间进行科学计算设备、模具的状态、维护进度、设备履历、模具履历等等进行汇总统计，并以记录、报表的形式进行展示",
  }, {
    title: "偏差管理",
    img: "022_m0",
    t1: "创建偏差管理任务",
    c1: "现场员工通过玩转工厂App，创建偏差管理任务，任务中包含偏差来源、类别、产品、产线、工位、客户、项目、安全法规、描述、图片等资料",
    t2: "偏差处置",
    c2: "创建人员、帮手，提交偏差内容、涉及零件，并提交给审核人员进行审核审批，并对结果予以记录",
    t3: "统计分析",
    c3: "后台AI服务器基于偏差记录数据以及统计规则，进行自动计算与统计偏差记录",
  }],
};

export {
  device,
  quality,
  user,
  products,
}



// WEBPACK FOOTER //
// ./src/js/infoData.js